import {axios} from "../../config/axios";

export const attachmentAPI = {
  createStashboardMedia(command) {
    const formData = new FormData();
    if (command.file) {
      formData.append('stashboard_media[attachment_attributes][file]', command.file);
    }
    if (command.label) {
      formData.append('stashboard_media[label]', command.label);
    }
    if (command.position) {
      formData.append('stashboard_media[position]', command.position);
    }
    if (command.url) {
      formData.append('stashboard_media[url]', command.url);
    }
    if (command.copy_stashboard_media_id) {
      formData.append('stashboard_media[copy_stashboard_media_id]', command.copy_stashboard_media_id);
    }
    if (command.copy_attachment_id) {
      formData.append('stashboard_media[copy_attachment_id]', command.copy_attachment_id);
    }
    formData.append('owner_type', command.owner_type)
    formData.append('owner_id', command.owner_id);

    return axios.post('/api/v3/stashboard_media', formData, {
      'Content-Type': 'multipart/form-data'
    }).then((resp) => resp.data);
  },
  bulkSaveStashboardMedia(command) {
    return axios.post(`/api/v3/stashboard_media/bulk_update`, command).then((resp) => resp.data);
  },

  create(ownerId, label, ownerType, file, permanent = null, mediaType = null) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('label', label);
    formData.append('owner_type', ownerType);
    formData.append('owner_id', ownerId);
    if (permanent !== null && permanent != undefined) {
      formData.append('permanent', permanent)
    }
    if (mediaType) {
      formData.append('media_type', mediaType)
    }

    return axios.post('/api/v3/attachments', formData, {
      'Content-Type': 'multipart/form-data'
    }).then((resp) => resp.data);
  },

  delete(uuid) {
    return axios.delete(`/api/v3/attachments/${uuid}`).then((resp) => resp.data);
  },

  removeStashboardMedia(id) {
    return axios.delete('/api/v3/stashboard_media/' + id).then(res => res.data)
  },
  storedMMS(ownerType) {
    return axios.get(`/api/v3/attachments/stored_mms`, {
      params: {
        owner_type: ownerType
      }
    }).then((resp) => resp.data);
  },

  forCampaign(campaignId, params) {
    return axios.get(`/api/v3/campaigns/${campaignId}/campaign_attachments`, {
      params
    }).then((resp) => resp.data);
  },
  getStashboardMedia(params) {
    return axios.get('/api/v3/stashboard_media/', {
      params
    }).then((resp) => resp.data);
  },
  getStashboardMediaHistory(params) {
    return axios.get('/api/v3/stashboard_media/history', {
      params
    }).then((resp) => resp.data);
  },
  forAutocampaign(campaignId, autocampaignId, params) {
    return axios.get(`/api/v3/campaigns/${campaignId}/campaign_attachments/auto_campaign_id=${autocampaignId}`, {
      params
    }).then((resp) => resp.data);
  },

  forReward(rewardId, ownerId, ownerType) {
    return axios.get(`/api/v3/campaign_rewards/${rewardId}/reward_attachments`, {
      params: {
        owner_id: ownerId,
        owner_type: ownerType
      }
    }).then((resp) => resp.data);
  }
}
